var waitFor = require('../utils/waitFor');

waitFor('select', function() {

  $('select:not(.no-selecter)').each(function(i, el){
		var $el = $(el),
			selecterOpts = {},
      cbStr = $el.data('selecter-callback');

    if (cbStr && cbStr.length > 0){
      $el.change(function(){
        window[cbStr].call();
      });
    }

  });

});
